/* eslint-disable linebreak-style */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from "react";
import { Helmet } from "react-helmet-async";

import Header1 from "parts/Header1";
import ProductsDroplet from "partsproducts/ProductsDroplet";
import ProductsMicroEdge from "partsproducts/ProductsMicroEdge";
import Footer from "parts/Footer";
import Products from "parts/ProductsBlog3.js";
import { Droplet, Microedge, Blog3 } from "../json/ProductsPageData.js";
import ProductSchema from "../utils/ProductsSchema.js";

export default class DropletPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Helmet>
          <title>LoRa® Sensors | Nube iO – Wireless Monitoring</title>
          <meta
            name="description"
            content="Nube iO's LoRa® sensors track temperature, humidity, light, motion, assets and more for up to 10 years on a single battery — reliable monitoring at scale."
          />
          <meta
            name="keywords"
            content="LoRa® sensors, IAQ monitoring sensor, environmental monitoring, IoT asset monitoring, wireless temperature sensor"
          />
          <link rel="canonical" href="https://nube-io.com/lorasensors/ " />
          <meta
            property="og:title"
            content="LoRa® Sensors | Nube iO – Wireless Monitoring"
          />
          <meta
            property="og:description"
            content="Nube iO's LoRa® sensors track temperature, humidity, light, motion, assets and more for up to 10 years on a single battery — reliable monitoring at scale."
          />
          <meta property="og:url" content="https://nube-io.com/lorasensors/" />
        </Helmet>
        <ProductSchema name="LoRa® Sensor" description="LoRa® is a low-power, long-range wireless technology designed for the Internet of Things." imagePath="/assets/images/Droplet01.png.png" />
        <Header1 />
        <ProductsDroplet data={Droplet} />
        <ProductsMicroEdge data={Microedge} />
        <Products data={Blog3} />
        <Footer />
      </>
    );
  }
}
